import { Update } from '../../types'

export interface UpdateTableData extends Update {
  isActive: boolean
}

export interface UpdatesPageProps {
  alertsAreSet: boolean
}

export interface CompanyUpdateData {
  type: 'company'

  // Added assets count in this particular update
  newAssetsCount?: number
  sector?: string
  newSubSectors?: string[]
  newPrimaryTherapeuticAreas?: string[]
  ipo?: string
  investmentTimeframe?: string
  corporateHistoryChange?: true
  newEvent?: {
    id: number
    name: string
  }
}

export interface AssetUpdateBaseData {
  type: 'asset'
  assetType: 'biotech' | 'medtech' | 'technologies' | 'services'

  sector?: string
  newSubSectors?: string[]
  newEvent?: {
    id: number
    name: string
  }
}

export interface BiotechAssetData extends AssetUpdateBaseData {
  assetType: 'biotech'

  clinicalStrategy?: string
  ipRights?: string
}

export interface MedtechAssetData extends AssetUpdateBaseData {
  assetType: 'medtech'
}

export interface TechnologiesAssetData extends AssetUpdateBaseData {
  assetType: 'technologies'
}

export interface ServicesAssetData extends AssetUpdateBaseData {
  assetType: 'services'
}

export interface DelegateUpdateData {
  type: 'delegate'

  newEvent?: {
    id: number
    name: string
  }
}

export interface AlertUpdateItem {
  userId: string
  sortKey: string
  profileId: string
  data: DelegateUpdateData | ServicesAssetData | TechnologiesAssetData | MedtechAssetData | BiotechAssetData | CompanyUpdateData
  updatedAt: string
  recordType: object
  title: string
  companyName?: string
}

export interface UpdatesPageDataDto {
  updates: {
    items: Update[]
  }
}

export const UPDATE_KEY_NAME_MAP = {
  sector: 'Main sector',
  addedSubSectors: 'Subsector',
  addedPrimaryTherapeuticAreas: 'Primary therapeutic area(s)',
  categorySector: 'Main sector',
  addedCategorySubSectors: 'Subsector',
  newEvent: 'event',
  addedAssetsCount: 'Assets count',
  addedServiceAvailability: 'Service Availability',
  ipRights: 'IP rights',
  clinicalStrategy: 'Clinical trials',
  differentiator: 'Partnering status',
  devPhase: 'Clinical phase',
  ipo: 'IPO year',
  investmentTimeframe: 'Investment timeframe',
}

export const BIOTECH_UPDATE_KEY_NAME_MAP = {
  ...UPDATE_KEY_NAME_MAP,
  categorySector: 'Main therapeutic sector',
  addedCategorySubSectors: 'Therapeutic subsector',
}

export const MEDTECH_UPDATE_KEY_NAME_MAP = {
  ...UPDATE_KEY_NAME_MAP,
  categorySector: 'Main therapeutic sector',
  addedCategorySubSectors: 'Therapeutic subsector',
}

export const SERVICES_UPDATE_KEY_NAME_MAP = {
  ...UPDATE_KEY_NAME_MAP,
  categorySector: 'Service category',
  addedCategorySubSectors: 'Subcategory',
}

export const TECHNOLOGIES_UPDATE_KEY_NAME_MAP = {
  ...UPDATE_KEY_NAME_MAP,
  categorySector: 'Main sector',
  addedCategorySubSectors: 'Subsector',
}

export const THREE_ROWS_MINIMUM_HEIGHT = 96
